// /patient — 덴탈클러스터 환자앱(구 환자앱, com.dentcluster.patient) 서비스 종료 안내 (2026-09-14 대표 결정: 즉시 종료)
// 이전 내용(스토어 다운로드 유도·방문 집계)은 전면 제거. 문안 정본: docs/구환자앱_종료고지_2026-09-14.md §2-1 (변경 시 법적보안 확인)
// 금지: 앱 설치 유도·덴클 앱 유도·혜택·무료 문구 (의료법·종료 고지 성격)
import React from 'react';
import PolicyNoticeBanner from './common/PolicyNoticeBanner';
import { CONTACT_EMAIL, CONTACT_PHONE } from './common/SiteFooter';

// 배너용 폴백 — Firestore config/policyNotices.patientapp_shutdown 값이 없을 때만.
// 정본 §2-1 문장에서 발췌(요청 기한 10-13·파기 10-14~10-19). 임시 폴백안의 "10월 14일까지"는 §2-1과 날짜가 어긋나 쓰지 않음
export const SHUTDOWN_FALLBACK = {
    title: '덴탈클러스터 환자앱 서비스 종료 안내',
    body: '덴탈클러스터 환자앱 서비스는 2026년 9월 14일에 종료되었습니다.\n자료가 필요하시거나 바로 삭제를 원하시면 2026년 10월 13일까지 dentcluster@gmail.com으로 요청해 주세요. 회원 정보와 자료는 2026년 10월 14일부터 파기하며 10월 19일까지 마칩니다.',
};

function PatientAppLanding() {
    return (
        <div style={S.body}>
            <div style={S.container}>
                {/* Firestore 고지 값(게시일·종료일·파기 일정). 문서가 없으면 폴백 문구 */}
                <PolicyNoticeBanner fallback={SHUTDOWN_FALLBACK} />

                <div style={S.header}>
                    <h1 style={S.title}>덴탈클러스터 환자앱 서비스 종료 안내</h1>
                </div>

                {/* 본문 = 종료고지 §2-1 확정 문안 그대로 */}
                <section style={S.section}>
                    <p style={S.p}>
                        주식회사 덴탈클러스터의 환자용 앱(덴탈클러스터 환자앱) 서비스는 2026년 9월 14일에 종료되었습니다. 미리 충분히 안내드리지 못한 점 양해 부탁드립니다.
                    </p>

                    <h2 style={S.h2}>1. 자료가 필요하신 경우</h2>
                    <ul style={S.ul}>
                        <li>앱에 올려 두신 영수증·사진 등 자료가 필요하시면 2026년 10월 13일까지 아래 이메일로 요청해 주세요. 본인 확인 후 전달해 드립니다.</li>
                    </ul>

                    <h2 style={S.h2}>2. 회원 정보와 자료의 파기</h2>
                    <ul style={S.ul}>
                        <li>회원 정보(이름·연락처·생년·성별 등), 올려 두신 자료, 즐겨찾기, 예약 요청 기록은 2026년 10월 14일부터 파기하며, 2026년 10월 19일까지 파기를 마칩니다.</li>
                        <li>그 전에 바로 삭제를 원하시면 아래 이메일로 요청해 주세요. 본인 확인 후 삭제합니다.</li>
                        <li>1:1 문의 내역은 분쟁 대응을 위해 최대 3년간 분리 보관한 뒤 파기합니다.</li>
                        <li>동의 기록은 개인을 알아볼 수 없는 형태(버전·일시)로만 최대 3년간 보관한 뒤 파기합니다.</li>
                    </ul>

                    <div style={S.box}>
                        <div>문의: 주식회사 덴탈클러스터 · <a href={`mailto:${CONTACT_EMAIL}`} style={S.link}>{CONTACT_EMAIL}</a> · {CONTACT_PHONE}</div>
                        <div style={{ marginTop: 4, color: '#64748b' }}>안내일·종료일: 2026-09-14 / 파기: 2026-10-14 ~ 2026-10-19</div>
                    </div>

                    {/* 동의 당시 문안 입증용 원문 링크 유지 (종료고지 §2-2 — 원문 삭제 금지) */}
                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 20 }}>
                        <a href="/patient/terms" style={S.link}>환자 회원 이용약관(종료 전 원문)</a>
                        <a href="/patient/privacy" style={S.link}>환자 개인정보처리방침(종료 전 원문)</a>
                    </div>
                </section>
            </div>
        </div>
    );
}

const S = {
    body: { backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: "'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif", color: '#0f172a', padding: '40px 20px' },
    container: { maxWidth: 760, margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: 14, border: '1px solid #e2e8f0' },
    header: { textAlign: 'center', marginBottom: 24, paddingBottom: 20, borderBottom: '2px solid #e2e8f0' },
    title: { fontSize: 24, fontWeight: 900, margin: 0 },
    section: { lineHeight: 1.8 },
    h2: { fontSize: 16, fontWeight: 800, marginTop: 24, marginBottom: 6 },
    p: { fontSize: 14, color: '#334155', marginBottom: 6 },
    ul: { fontSize: 14, color: '#334155', paddingLeft: 20, margin: '4px 0' },
    box: { fontSize: 13.5, color: '#0f172a', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px', marginTop: 20 },
    link: { color: '#0369a1', textDecoration: 'underline', fontSize: 13.5 },
};

export default PatientAppLanding;
